import { configureStore } from "@reduxjs/toolkit";
import authTeacherReducer from "./authTeacher/slice.js";
import teacherReducer from "./teacher/slice.js";
import studentReducer from "./student/slice.js";
import authStudentReducer from "./authStudent/slice.js";
import teacherSlotsReducer from "./teacherSlots/slice.js";
import studentBookingsReducer from "./studentBookings/slice.js";
import publicTeacherReducer from "./publicTeacher/slice.js";
import teacherBookingsReducer from "./teacherBookings/slice.js";
import studentPublicReducer from "./studentPublic/slice.js";
import availableSlotsReducer from "./availableSlots/slice.js";
import chatReducer from "./chat/slice.js";
import { videoReducer } from "./video/slice.js";
import resetPassword from "./passwordReset/slice.js";
import studentFavoritesReducer from "./studentFavorites/slice.js";
import teacherFavoritesReducer from "./teacherFavorites/slice.js";
import teacherReviewsReducer from "./teacherReviews/slice.js";
import feedbackReducer from "./feedback/slice.js";
import teacherScoreReducer from "./teacherScore/slice.js";
import teacherSubscriptionReducer from "./teacherSubscription/slice.js";
export const store = configureStore({
  reducer: {
    authTeacher: authTeacherReducer,
    authStudent: authStudentReducer,
    teacher: teacherReducer,
    teacherSlots: teacherSlotsReducer,
    student: studentReducer,
    studentBookings: studentBookingsReducer,
    teacherBookings: teacherBookingsReducer,
    publicTeacher: publicTeacherReducer,
    studentPublic: studentPublicReducer,
    chat: chatReducer,
    availableSlots: availableSlotsReducer,
    video: videoReducer,
    passwordReset: resetPassword,
    studentFavorites: studentFavoritesReducer,
    teacherFavorites: teacherFavoritesReducer,
    teacherReviews: teacherReviewsReducer,
    feedback: feedbackReducer,
    teacherScore: teacherScoreReducer,
    teacherSubscription: teacherSubscriptionReducer,
  },
});
